import type {FC} from 'react';

import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';
import {PortableText} from '@/modules/foundation/sanity/portable-text';
import {
	HeroWithSideImage,
	heroWithSideImagePortableTextOverrides,
} from '@/modules/page/components/page-head/hero-with-side-image';

import type {HeroWithSideImageSchema} from './schema';

interface Props {
	data: HeroWithSideImageSchema;
}

export const HeroWithSideImageContainer: FC<Props> = ({
	data: {image, heading, introduction, backgroundColor, imagePlacement},
}) => {
	let sideImage;

	if (image?.asset?._ref) {
		sideImage = imageWebFromImageWebSchema(image);
	}

	return (
		<HeroWithSideImage
			imageWeb={sideImage}
			heading={heading}
			backgroundColor={backgroundColor}
			imagePlacement={imagePlacement}
		>
			{introduction && (
				<PortableText
					blocks={introduction}
					overrideClassNames={heroWithSideImagePortableTextOverrides}
					theme={backgroundColor}
				/>
			)}
		</HeroWithSideImage>
	);
};
